import md5 from 'js-md5'
const env = require('../env')
const packageJson = require('../package.json')
const replaceData = val => {
	let replaceval = val.replace(/[(]/g, '%28')
	replaceval = replaceval.replace(/[)]/g, '%29')
	replaceval = replaceval.replace(/[']/g, '%27')
	replaceval = replaceval.replace(/[*]/g, '%2A')
	replaceval = replaceval.replace(/[~]/g, '%7E')
	replaceval = replaceval.replace(/[!！]/g, '%21')
	return replaceval
}

let timeDiff = null
let timeDiffPromise = null
export async function getTimeStamp() {
	if (timeDiff !== null) return Date.now() + timeDiff
	async function setTimeDiff() {
		try {
            const response = await fetch(`${env[packageJson.env].ENV_TIME_API}/server/time`)
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`)
			}
			const data = await response.json()
			if (data) {
				timeDiff = data.data - Date.now()
			}
		} catch (error) {
			console.error('Error fetching time difference:', error)
			// 根据需要进行错误处理，比如设置默认值或提示用户
		}
	}

	if (!timeDiffPromise) timeDiffPromise = setTimeDiff()

	await timeDiffPromise
	return Date.now() + timeDiff // 返回正确时间戳
}
/**
 * 获取签名
 * @param {*} params
 * @param {*} method
 * @param {*} useNodeServerTime
 * @returns
 */
export const getSignature = async (params, method, useNodeServerTime = false) => {
	let paramData = method ? params : { ...params }
	// 当前时间戳
	let Timestamp = useNodeServerTime ? Date.now() : await getTimeStamp()
	// 随机数
	let Random = ''
	let code = ''
	let codeLength = 6
	let random = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9)
	for (let i = 0; i < codeLength; i++) {
		let index = Math.floor(Math.random() * 9)
		code += random[index]
	}
	Random = Number(code)
	let arr = []
	if (method) {
		if (paramData) {
			arr.push('PZTimestamp=' + Timestamp + '&Random=' + Random + '&' + 0x7fffffff + '=' + encodeURIComponent(JSON.stringify(paramData)))
		} else {
			arr.push('PZTimestamp=' + Timestamp + '&Random=' + Random + '=' + encodeURIComponent(JSON.stringify(paramData)))
		}
	} else {
		paramData.PZTimestamp = Timestamp
		paramData.Random = Random
		// 排序
		let keysArr = Object.keys(paramData).sort()
		keysArr = keysArr.sort((a, b) => {
			return a - b
		})
		let sortObj = {}
		for (let i in keysArr) {
			if (paramData[keysArr[i]] instanceof Array && paramData[keysArr[i]] instanceof Object) {
				paramData[keysArr[i]] = JSON.stringify(paramData[keysArr[i]])
			}
			sortObj[keysArr[i]] = encodeURIComponent(paramData[keysArr[i]])
		}
		paramData = sortObj
		for (let i in paramData) {
			if (method) {
				arr.push(i + '=' + paramData[i])
			} else {
				if (paramData[i] !== 'null' && paramData[i] !== 'undefined') {
					arr.push(i + '=' + paramData[i])
				}
			}
		}
	}
	let newUrl = arr.join('&') + '&accessKey=' + '3qXyB7uf'
	newUrl = replaceData(newUrl)
	let strMd5 = md5(newUrl)

	return {
		Timestamp,
		strMd5,
		Random
	}
}

/**
 * 获取操作系统 OS
 */
export function getOS() {
	let userAgent = navigator.userAgent
	let userAgentData = navigator.userAgentData
	let os = 'windows'

	if (userAgentData) {
		// User-Agent Client Hints API (navigator.userAgentData)
		var platform = userAgentData.platform || userAgentData.brands.map(brand => brand.brand).join(' ')
		if (platform.includes('Windows')) {
			os = 'windows'
		} else if (platform.includes('macOS') || platform.includes('Macintosh')) {
			os = 'Mac'
		} else if (platform.includes('iOS') || platform.includes('iPhone') || platform.includes('iPad') || platform.includes('iPod')) {
			os = 'ios'
		} else if (platform.includes('Android')) {
			os = 'android'
		} else if (platform.includes('Linux')) {
			os = 'linux'
		}
	} else {
		// Fallback to userAgent string
		if (/Windows/i.test(userAgent)) {
			os = 'windows'
		} else if (/Mac/i.test(userAgent)) {
			os = 'Mac'
		} else if (/iPhone|iPad|iPod/i.test(userAgent)) {
			os = 'ios'
		} else if (/Android/i.test(userAgent)) {
			os = 'android'
		} else if (/Linux/i.test(userAgent)) {
			os = 'linux'
		}
	}

	return os
}
